import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import usePartnerPromoOffers from 'luxPlus/hooks/usePartnerPromoOffers'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

const OfferGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const OfferCard = styled(Pane)`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  height: 100%;
  border: none;
`

const OfferImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${rem(200)};
  overflow: hidden;

  /*
   * Logo/Image components (TuroLogo, HelloFreshLogo, Image) define their own
   * intrinsic sizes for use elsewhere (e.g. modals, inline text). To ensure
   * uniform card images here, we override those internal dimensions by
   * stretching all children to fill this fixed-size container.
   */
  > *, picture {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  img, svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

function LuxPlusLandingPartnerOffersList() {
  const intl = useIntl()
  const partnerOffers = usePartnerPromoOffers()

  if (!partnerOffers.length) return null

  return (
    <Section background="neutral-eight">
      <LayoutContainer>
        <VerticalSpacer gap={24}>
          <Heading variant="heading3" align="center">
            {intl.formatMessage({
              id: 'VtV6Adv0KrxLTr_niq0u',
              defaultMessage: 'Exclusive partner offers',
              description: 'Heading for exclusive partner offers list on LuxPlus landing page',
            })}
          </Heading>
          <OfferGrid>
            {partnerOffers.map(offer => (
              <OfferCard
                key={offer.id}
                background="neutral-eight"
                borderRadius="L"
              >
                <OfferImageContainer>
                  {offer.logo}
                </OfferImageContainer>
                <Group direction="vertical" gap={16}>
                  <Heading variant="heading4">{offer.title}</Heading>
                  <BodyText variant="medium">{offer.description}</BodyText>
                  {offer.onViewDetails && <TextLink size="medium" weight="regular" onClick={offer.onViewDetails}>
                    {offer.ctaLabel}
                  </TextLink>}
                </Group>
              </OfferCard>
            ))}
          </OfferGrid>
        </VerticalSpacer>
      </LayoutContainer>
    </Section>
  )
}

export default LuxPlusLandingPartnerOffersList
